import { generatedKeys } from '@app/data';
import { fetchLocales, Locals } from '@app/Services/App';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

export const useFetchLocals = (
	opt?: UseQueryOptions<Awaited<ReturnType<typeof fetchLocales>>>
) => {
	const q = useQuery<Awaited<ReturnType<typeof fetchLocales>>>({
		queryFn: fetchLocales,
		staleTime: Infinity,
		queryKey: generatedKeys.translations.locales?.({})!,
		...opt,
	});

	if (q.error) {
		Sentry.captureException(q.error);
	}

	return {
		...q,
		data: q?.data as Locals[] | undefined,
		isLocalesLoading: q?.isLoading,
	};
};
